import { ExportLogExportButton, ExportLogTable } from 'components/logsExport'
import { Helmet } from 'react-helmet'

/**
 * Export Logs page
 */
const ExportLog = () => {
  return (
    <>
      <Helmet>
        <title>ORMS Import Logs </title>
      </Helmet>
      <ExportLogExportButton />
      <ExportLogTable />
    </>
  )
}

export default ExportLog
